import { render } from "./Hue.vue?vue&type=template&id=7b983451&scoped=true&ts=true"
import script from "./Hue.vue?vue&type=script&lang=ts"
export * from "./Hue.vue?vue&type=script&lang=ts"

import "./Hue.vue?vue&type=style&index=0&id=7b983451&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b983451"]])

export default __exports__